import { emitter } from 'shared/helpers/mitt';
import { BUS_EVENTS } from 'shared/constants/busEvents';

// Scroll the open chat to a message. If it predates the loaded window, one
// ranged fetch (?after=<target>&before=<oldest loaded>) pulls the gap first —
// MessageFinder#messages_between is target-inclusive and capped, so this is a
// single bounded request, never a scroll-up loop.
export const jumpToChatMessage = async (store, chat, id) => {
  const messageId = Number(id);
  const { id: conversationId, messages = [] } = chat;
  const isLoaded = messages.some(m => Number(m.id) === messageId);
  if (!isLoaded && messages.length && Number(messages[0].id) > messageId) {
    await store.dispatch('fetchPreviousMessages', {
      conversationId,
      after: messageId,
      before: messages[0].id,
    });
  }
  emitter.emit(BUS_EVENTS.SCROLL_TO_MESSAGE, { messageId });
};
